import type { ReactNode } from "react";
import { Label as RACLabel } from "react-aria-components";
import clsx from "clsx";

import styles from "./label.module.css";

interface LabelProps {
  id?: string;
  children: ReactNode;
  className?: string;
  display?: { orientation?: "row" | "column" };
}

function Label({ children, id, className, display }: LabelProps) {
  const orientation = display?.orientation || "column";
  return (
    <RACLabel
      data-testid="pallet-label"
      id={id}
      className={clsx(styles.label, className, {
        [styles.row]: orientation === "row",
      })}
    >
      {children}
    </RACLabel>
  );
}

export default Label;
